/* Dynamic Plot code copyright 2015 (c) Tuva Labs Inc. */
/**
 *
 * created by jpatel
 */

import React from 'react';

class NumericalIntervalComponent extends React.Component {
  constructor(props) {
    super(props);
    let Dyn = this.props.Dyn;

    /**
     * set the initial value based on the attribute format object, which
     * consists decimals, width and Start
     */
    var format = Dyn.dataSet.getAttributeByID( this.props.attributeObj.id ).format;

    // Storing last
    this.numericIntervalWidth = format.numericIntervalWidth ? format.numericIntervalWidth : this.props.numericIntervalWidth,
    this.numericIntervalStart = ( format.numericIntervalStart !== undefined ) ? format.numericIntervalStart : this.props.numericIntervalStart;

    this.state = {
      numericIntervalWidth: this.numericIntervalWidth,
      numericIntervalStart: this.numericIntervalStart,
      maxStartValueAllowed: this.props.maxStartValueAllowed
    };
  }

  onChange = ( value, eleName ) => {
    // Start value for the interval should not be greater than min value for
    // numerical attribute
    // TODO: put some message when user it doesn't meet the condition.
    if (eleName === 'numericIntervalStart' && value > this.state.maxStartValueAllowed ) {
      value = this.state.maxStartValueAllowed;
    }

    // Set changed value
    var stateObject = {};
    stateObject[eleName] = value;
    this.setState(stateObject);

    if(this.inputChangeTimeout) {
        clearTimeout(this.inputChangeTimeout);
    }
    this.inputChangeTimeout = setTimeout(function(){
        this.actualOnChange(value, eleName);
    }.bind(this), 500);
  }

  actualOnChange = ( value, eleName ) => {
    if( value && !isNaN(value)) {
      this[eleName] = Number(value);
      // message to parent to rerender
      this.props.handleChange({
        filterChanged: true,
        dataType: 'numerical',
        component: 'numeric-interval',
        numericInterval: {
            width: this.numericIntervalWidth,
            start: this.numericIntervalStart
        }
      });
    }
  }

  onBlur = ( eleName ) => {
    // check the classname and value in obj.target
    setTimeout(() => {
      var stateObject = {};
      stateObject[eleName] = this[eleName];
      this.setState(stateObject);
    }, 500);
  }

  getLoc = (str) => {
    let Dyn = this.props.Dyn;
      return Dyn.loc( str );
  }

  render = () => {

    var numericIntervalStart = this.state.numericIntervalStart,
        numericIntervalWidth = this.state.numericIntervalWidth;

    if( this.props.resetFilter ){
      numericIntervalStart = this.props.attributeObj.format.numericIntervalStart;
      numericIntervalWidth = this.props.attributeObj.format.numericIntervalWidth;
    }

    return (
      <div className={"tde-numeric-interval-component tde-mt-2" + (this.props.reduceCaseCardWidth ? ' tde-px-2':' tde-px-3')}>
        <div className="tde-row tde-pr-3">
          <div className="tde-label tde-mb-1">{ this.getLoc('Start') }:</div>
          <input type="text" className="tde-input tde-input-text"
              onChange={e => {this.onChange(e.target.value, 'numericIntervalStart')}}
              onBlur={e => {this.onBlur('numericIntervalStart')}}
              value={numericIntervalStart} />
        </div>
        <div className="tde-row">
          <div className="tde-label tde-mb-1">{ this.getLoc('Width') }:</div>
          <input type="text" className="tde-input tde-input-text"
              onChange={e => {this.onChange(e.target.value, 'numericIntervalWidth')}}
              onBlur={e => {this.onBlur('numericIntervalWidth')}}
              value={numericIntervalWidth} />
        </div>
      </div>
    );
  }
}

export default NumericalIntervalComponent;
